import * as React from 'react';
import { BillingDocContactDetailBlock, AuditNotes, useFeatureToggle } from '@css-xp/base';
import { Refund } from '@atlassian/cssxp-types-billing';
import { EntityWithNotes } from '@atlassian/cssxp-types-audit';
import { getRefundAdditionalDetail } from '../refund-page-utils';
import RefundLineItems from './refund-line-items';
import { ENABLE_CREDIT_NOTES_TRANSACTION_ACCOUNT } from '@atlassian/cssxp-utils-generic';

export const RefundDetail = ({ refund }: { refund: Refund }) => {
  const { id, billTo, creditNoteId } = refund;
  const [isEnabled] = useFeatureToggle();
  const flag = isEnabled(ENABLE_CREDIT_NOTES_TRANSACTION_ACCOUNT);

  const auditTrailProps = {
    entityName: EntityWithNotes.REFUND,
    id: creditNoteId ?? id,
  };

  return (
    <div className="billing-details">
      <div className="billing-document-contact-blocks">
        <div className="bill-to">
          <h4>Billing contact</h4>
          <BillingDocContactDetailBlock contact={billTo} />
        </div>
        {getRefundAdditionalDetail(refund)}
      </div>
      <RefundLineItems {...refund} />
      <div className="audit-trail-block">
        <AuditNotes {...auditTrailProps} />
      </div>
    </div>
  );
};
